import { useEffect } from 'react';
import { matchPath, useBlocker } from 'react-router-dom';

import { UseCreditAgreementStore } from './store';

export const usePreventAccidentalNavigation = (
  useStore: UseCreditAgreementStore,
  facilityId: string,
) => {
  const shouldBlock = useStore((store) => store.isCreditAgreementDirty);

  useEffect(() => {
    const beforeUnloadHandler = (event: BeforeUnloadEvent) => {
      if (!shouldBlock) return;
      event.preventDefault();

      const evt = event; // Avoids param reassignment
      evt.returnValue = true; // For legacy browsers
    };

    window.addEventListener('beforeunload', beforeUnloadHandler);
    return () =>
      window.removeEventListener('beforeunload', beforeUnloadHandler);
  }, [shouldBlock]);

  // useBlocker prevents navigation via react-router while the credit agreement is dirty
  useBlocker(({ nextLocation }) => {
    if (!shouldBlock) return false;

    const match = matchPath(
      {
        path:
          '/settings/implementations/:implementationId/facilities/:facilityId',
        end: false, // allows for nested routes
      },
      nextLocation.pathname,
    );

    const isSameFacility = match?.params.facilityId === facilityId;

    if (!isSameFacility) {
      // eslint-disable-next-line no-alert
      return !window.confirm('Leave page? Changes you made may not be saved.');
    }

    return false;
  });
};
